import { Actions as RemoveSnackbarAction } from '../actions/removeSnackbar';
import { Actions as EnqueueSnackbarAction } from '../actions/enqueueSnackbar';
import { NotistackSnackbar } from '../interfaces/notistackSnackbar';

export type State = {
  snackbars: NotistackSnackbar[];
};

export const initialState: State = {
  snackbars: []
};

type Actions = EnqueueSnackbarAction | RemoveSnackbarAction;

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'ENQUEUE_SNACKBAR':
      return {
        ...state,
        snackbars: [...state.snackbars, action.payload]
      };
    case 'REMOVE_SNACKBAR':
      return {
        ...state,
        snackbars: state.snackbars.filter(notification => notification.key !== action.payload)
      };
    default:
      return state;
  }
}
